var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisitanawhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.454 26H2.54678C1.1403 26 0 24.776 0 23.2632V3.02739C0 1.22585 1.1403 0 2.54678 0H23.2337H23.4974H25.454C26.8605 0 28 1.22585 28 3.02739V23.2632C28 24.776 26.8605 26 25.454 26ZM25.454 14.9692L24.8437 16.0516L19.4611 10.6918L14.3709 17.5339L10.4465 13.3148L9.00185 14.8679C8.81195 16.3717 7.62508 17.5339 6.17451 17.5339C4.59169 17.5339 3.30816 16.1538 3.30816 14.4518C3.30816 12.7498 4.59169 11.3706 6.17451 11.3706C6.86716 11.3706 7.9218 11.645 7.98962 12.0853L10.4465 9.44445L14.1598 13.4358L19.2499 6.59461L24.8437 12.1804L25.454 11.0971V3.02739H23.4974H23.2337H2.54678V23.2632H25.454V14.9692ZM7.09092 22.414H4.54672V18.3114H7.09092V22.414ZM12.1819 22.414H9.63604V15.5745H12.1819V22.414ZM17.2737 22.414H14.7287V18.3114H17.2737V22.414ZM22.3647 22.414H19.8196V15.5745H22.3647V22.414Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitanawhite);
export default __webpack_public_path__ + "static/media/visitanawhite.42a42ce5c263e60f9c88bfc45ab50fbd.svg";
export { ForwardRef as ReactComponent };